import Icon from '@ux/icon';
import React from 'react';
import PropTypes from 'prop-types';
import IndicatorBase from './indicator-base';

/**
 * Indicator icon
 *
 * @displayName Indicator (Web)
 * @class Indicator
 * @public
 */
export default class Indicator extends IndicatorBase {

  /**
   * Get the visual indicator
   *
   * @returns {React.DOM} visual status indicator.
   * @private
   */
  render() {
    if (!this.active()) return null;

    const wrapperClass = this.classNames(this.props.background, 'indicator');

    return (
      <div className={ wrapperClass }>
        <Icon name={ this.props.icon } size={ 10 } color='white' />
      </div>
    );
  }
}

Indicator.propTypes = {
  /** Name of the icon to display. */
  icon: PropTypes.string,
  /** Background class to use. */
  background: PropTypes.string
};
